
const themesLicensed = [
    {
        licensedId: 4759,
        domain: "https://safe.movyx.com.br/",
        active: "S",
        companyLogo: "Logo53.jpg",
        homeScreenImage: "photo53.avif",
        colors: {
            light_theme: {

                themePrimary: "#1F3A5F",
                themeSecondary: "#162B45",
                themeTertiary: "#FF7A1A",
                themeSupport: "#FFD1A8",

                bgPrimary: "#FFFFFF",
                bgSecondary: "#F4F7FB",
                bgTertiary: "#E6EDF5",
                bgCard: "#FFFFFF",
                bgSidebar: "#F4F7FB",
                bgNavbar: "#EDF2F9",
                bgContent: "#F8FAFD",
                bgGrid: "#E0E6EF",
                bgGridAltrow: "#FFFFFF",

                textPrimary: "#1F3A5F",
                textSecondary: "#5A6D85",
                textMuted: "#A5B1C2",
                textInverse: "#FFFFFF",

                borderPrimary: "#D6DEE8",
                borderSecondary: "#EDF2F9",
                borderFocus: "#FF7A1A",

                statusSuccess: "#28A745",
                statusWarning: "#FF7A1A",
                statusDanger: "#DC3545",
                statusInfo: "#1F3A5F",

                chart1: "#1F3A5F",
                chart2: "#FF7A1A",
                chart3: "#5A6D85",
                chart4: "#FFD1A8",
                chart5: "#162B45",
                chart6: "#FFA861",
                chart7: "#3C5A80",
                chart8: "#FFE8D6",

                bgFilterPrimary: "#F4F7FB",
                colorFontFilterPrimary: "#1F3A5F",
                borderColorFilterPrimary: "#D6DEE8",
                bgColorTitleBar: "#EDF2F9",
                bgMenuItem: "#E6EDF5",
                bgScrollBar: "#FF7A1A",

                menu: {
                    bgMain: "#F4F7FB",
                    bgEnabled: "#E6EDF5",
                    textDisabled: "#A5B1C2",
                    textEnabled: "#1F3A5F",
                    textHover: "#FF7A1A"
                },

                cards: {
                    background: "#FFFFFF",
                    title: "#1F3A5F",
                    subtitle: "#5A6D85",
                    value: "#FF7A1A"
                },

                filters: {
                    background: "#FFFFFF",
                    title: "#1F3A5F",
                    subtitle: "#162B45",
                    border: "#D6DEE8"
                },

                tables: {
                    headerBg: "#1F3A5F",
                    text: "#1F3A5F",
                    rowBg: "#FFFFFF",
                    rowBgAlt: "#F4F7FB",
                    paginationText: "#FF7A1A",
                    paginationHover: "#EDF2F9"
                },

                buttons: {
                    bgBtnPrimary: "#1F3A5F",
                    bgBtnSecondary: "#5A6D85",
                    bgBtnTertiary: "#FF7A1A",
                    btnSuccess: "#28A745",
                    textPrimary: "#FFFFFF",
                    textSecondary: "#FFFFFF",
                    textHoverPrimary: "#FFFFFF",
                    textHoverSecondary: "#FFFFFF"
                }
            },

            dark_theme: {

                bgPrimary: "#0E1C30",
                bgSecondary: "#0A1424",
                bgTertiary: "#152841",
                bgCard: "#0F2137",
                bgSidebar: "#0A1424",
                bgNavbar: "#0E1C30",
                bgContent: "#0E1C30",
                bgGrid: "#1C3554",
                bgGridAltrow: "#152841",

                textPrimary: "#FFFFFF",
                textSecondary: "#B0BDD0",
                textMuted: "#6C7C95",
                textInverse: "#1F3A5F",

                borderPrimary: "#1C3554",
                borderSecondary: "#152841",
                borderFocus: "#FF7A1A",

                bgFilterPrimary: "#0A1424",
                colorFontFilterPrimary: "#FF7A1A",
                borderColorFilterPrimary: "#1C3554",
                bgColorTitleBar: "#0E1C30",
                bgMenuItem: "#09111F",
                bgScrollBar: "#FF7A1A",

                menu: {
                    bgMain: "#0A1424",
                    bgEnabled: "#09111F",
                    textDisabled: "#B0BDD0",
                    textEnabled: "#FFFFFF",
                    textHover: "#FF7A1A"
                },

                cards: {
                    background: "#0F2137",
                    title: "#FFFFFF",
                    subtitle: "#B0BDD0",
                    value: "#FF7A1A"
                },

                filters: {
                    background: "#0A1424",
                    title: "#FF7A1A",
                    subtitle: "#FFFFFF",
                    border: "#1C3554"
                },

                tables: {
                    headerBg: "#1F3A5F",
                    text: "#FFFFFF",
                    rowBg: "#0E1C30",
                    rowBgAlt: "#152841",
                    paginationText: "#FF7A1A",
                    paginationHover: "#FFFFFF"
                },

                buttons: {
                    bgBtnPrimary: "#1F3A5F",
                    bgBtnSecondary: "#5A6D85",
                    bgBtnTertiary: "#FF7A1A",
                    btnSuccess: "#28A745",
                    textPrimary: "#FFFFFF",
                    textSecondary: "#FFFFFF",
                    textHoverPrimary: "#FFFFFF",
                    textHoverSecondary: "#FFFFFF"
                }
            }
        },
        phrase: "Semeando Futuro",
        companyPhone: "(12)3570-1100",
        centralPhone: "0800-601-2600",
        standardLanguage: "pt-br",
        currentLanguage: "pt-br"
    }
]

export default themesLicensed;

// menu: {
//     bgMain: "#F8F9FA",
//     bgEnabled: "#efefef",
//     textDisabled: "#6C757D",
//     textEnabled: "#2C3E50",
//     textHover: "#009E80",
// },

// cards: {
//     background: "#FFFFFF",
//     title: "#2C3E50",
//     subtitle: "#6C757D",
//     value: "#009E80",
// },

// filters: {
//     background: "#FFF",
//     title: "#3BB4B4",
//     subtitle: "#2C3E50",
//     border: "#555555"
// },

// tables: {
//     headerBg: "#666666",
//     text: "#2C3E50",
//     rowBg: "#FFF",
//     rowBgAlt: "#626262",
//     paginationText: "#009E80",
//     paginationHover: "#e9ecef"
// },

// buttons: {
//     bgBtnPrimary: "#009E80",
//     bgBtnSecondary: "#8592a3",
//     bgBtnTertiary: "#e69a00",
//     btnSuccess: "#66c732",
//     textPrimary: "#2C3E50",
//     textSecondary: "#FFFFFF",
//     textHoverPrimary: "#FFFFFF",
//     textHoverSecondary: "#FFFFFF",
// }
// menu: {
//     bgMain: "#212727",
//     bgEnabled: "#1A1A1A",
//     textDisabled: "#B7C0C0",
//     textEnabled: "#FFFFFF",
//     textHover: "#009E80",
// },
// cards: {
//     background: "#212727",
//     title: "#FFFFFF",
//     subtitle: "#B7C0C0",
//     value: "#009E80",
// },
// filters: {
//     background: "#212727",
//     title: "#3BB4B4",
//     subtitle: "#fff",
//     border: "#555555"
// },
// tables: {
//     headerBg: "#666666",
//     text: "#fff",
//     rowBg: "#293333",
//     rowBgAlt: "#3F4545",
//     paginationText: "#009E80",
//     paginationHover: "#FFF"
// },
// buttons: {
//     bgBtnPrimary: "#009E80",
//     bgBtnSecondary: "#8592a3",
//     bgBtnTertiary: "#e69a00",
//     btnSuccess: "#66c732",
//     textPrimary: "#2C3E50",
//     textSecondary: "#FFFFFF",
//     textHoverPrimary: "#FFFFFF",
//     textHoverSecondary: "#FFFFFF",
// }